module.exports = __webpack_public_path__ + "static/media/search-list.887d90f2.svg";